import { useQuoteModal } from '../../../context/QuoteModalContext';

export default function Hero() {
  const { openModal } = useQuoteModal();
  return (
    <section className="relative w-full h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="/assets/img/7d701b6c519f.webp"
        alt="Engineering & Safety hero"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>
      <div className="relative z-10 text-center w-full px-4">
        <h1 className="text-6xl md:text-7xl font-extrabold text-white mb-5 tracking-tight leading-tight">
          Engineering &amp; Safety
        </h1>
        <p className="text-xl md:text-2xl text-white/85 mb-10 font-light max-w-3xl mx-auto">
          Structural integrity, fire compliance, and engineered rigging data you can trust
        </p>
        <button
          type="button"
          onClick={openModal}
          className="inline-block bg-teal-400 hover:bg-teal-500 text-white px-10 py-4 rounded-lg font-semibold text-base transition-colors whitespace-nowrap cursor-pointer"
        >
          Request Technical Specs
        </button>
      </div>
    </section>
  );
}